import { render, staticRenderFns } from "./explain-results-tiebreakers-row.component.vue?vue&type=template&id=52db355a&scoped=true"
import script from "./explain-results-tiebreakers-row.component.vue?vue&type=script&lang=ts"
export * from "./explain-results-tiebreakers-row.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-results-tiebreakers-row.component.vue?vue&type=style&index=0&id=52db355a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db355a",
  null
  
)

export default component.exports